import { useFormContext } from "react-hook-form"
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form"
import DatePicker from "@/components/ui/date-picker"
import { RequiredMark } from "./required-mark"

interface FormDateFieldProps {
  name: string
  label: string
  placeholder?: string
  required?: boolean
  disabled?: boolean
  className?: string
}

export function FormDateField({
  name,
  label,
  placeholder,
  required,
  disabled,
  className,
}: FormDateFieldProps) {
  const { control } = useFormContext()

  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className={className}>
          <FormLabel className="text-gray-200 text-sm font-semibold">
            {label}
            {required && <RequiredMark />}
          </FormLabel>
          <FormControl>
            <DatePicker field={field} placeholder={placeholder} disabled={disabled} />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  )
}